import { BootstrapTable } from 'react-bootstrap-table';
import React from 'react';
import store from '@/store/store';
import { replace } from 'react-router-redux';

export class ReactBootstrapTableRemotePagination extends BootstrapTable {
  componentWillMount() {
    if (!this.props.dontUseRemotePagination &&
    this.context.location &&
    this.context.location.query &&
    this.context.location.query.pageSize &&
    this.context.location.query.pageNumber) {
      this.handlePaginationData(parseInt(this.context.location.query.pageNumber, 10),
        parseInt(this.context.location.query.pageSize, 10));
    }
    if (super.componentWillMount) { super.componentWillMount(); }
  }

  componentDidUpdate() {
    if (!this.props.dontUseRemotePagination && (!this.context.location ||
    !this.context.location.query ||
    this.context.location.query.pageSize != this.state.sizePerPage ||
    this.context.location.query.pageNumber != this.state.currPage)) {
      store.dispatch(replace(
        `${window.location.pathname}?pageNumber=${this.
          state.currPage}&pageSize=${this.state.sizePerPage}`
      ));
    }
    if (super.componentDidUpdate) { super.componentDidUpdate(); }
  }
}

ReactBootstrapTableRemotePagination.contextTypes = {
  location: React.PropTypes.object,
};
